module.exports = __webpack_public_path__ + "img/wangdee_logo.9137d9b5.png";